import axios from "axios";
import { useMemo, useState } from "react";



interface api {
    loading: boolean;
    error: boolean;
    data: any;
}

const getPrices = async () => {
    try {
        const { data } = await axios.get(
            process.env.REACT_APP_API_URL + "/topCollectionBySales?duration=0"
        )
        return data;
    }
    catch (error) {
        return error;
    }
}

export function useHighestNFTSale() {
    const [api, setAPIData] = useState<api>({
        loading: true,
        error: false,
        data: "",
    });



    useMemo(async () => {
        const data = await getPrices();
        setAPIData({
            loading: false,
            error: false,
            data: data
        })
    }, [])
    return api;
}
